import axios from 'axios';
import $ from 'jquery';

import { store } from '../store';
import { TCF_URL } from '../api/URLs';
import { donationAPIs } from '../api';
import { checkoutActions, donationActions } from '../store/actions';
import { ACH, APPLE, GOOGLE, STRIPE } from '../constants';
import { compiledName, convertFirstLetterToUpperCase, totalCheckoutDonation } from './CommonFunctions';

export const confirmStripeCardPayment = async (stripeIntentResponse, state, stripeReference) => {
	let stripeResponse = {};
	const isGoogleApplePay = state.selectedPaymentMethod == GOOGLE || state.selectedPaymentMethod == APPLE;

	let paymentIntentSecret = state.recurringDonation ? stripeIntentResponse.payment_intent : stripeIntentResponse.client_secret;

	if (stripeIntentResponse?.payment_status?.status === 'succeeded') {
		stripeResponse = {
			paymentIntent: stripeIntentResponse.payment_status,
		};
	} else stripeResponse = await stripeReference.current.handleToken(paymentIntentSecret, state.recurringDonation);

	if (stripeResponse) stripeResponse.is_google_apple_pay = isGoogleApplePay;

	return stripeResponse;
};

export const getStripeIntent = async (payload, isFundraiserCheckout) => {
	const isCampaignPage = isFundraiserCheckout ? 0 : 1;

	const response = await donationAPIs.getStripIntent(payload, isCampaignPage);
	if (response.data && response.data.success) return response.data.success;
};

export const StripeCheckout = async (payload, stripeIntentResponse, state, dispatch) => {
	const stripeResponse = await confirmStripeCardPayment(stripeIntentResponse, state);
	if (stripeResponse) {
		const userDetailsWithStripeResponse = { ...payload, ...stripeResponse };
		state.isFundraiserCheckout
			? dispatch(donationActions.checkoutStripe(userDetailsWithStripeResponse))
			: dispatch(donationActions.checkoutStripe(userDetailsWithStripeResponse, 1));
		return userDetailsWithStripeResponse;
	} else return false;
};

export const handleStripe = async (payload, state) => {
	const globalState = store.getState();

	const stripeReference = globalState.checkoutPaymentRefs.stripeReference;
	const googleApplePayReference = globalState.checkoutPaymentRefs.googleApplePayReference;

	const stripeRef = state.selectedPaymentMethod == STRIPE ? stripeReference : googleApplePayReference;
	try {
		const stripeIntent = await getStripeIntent(payload, state.isFundraiserCheckout);
		const stripeResponse = await confirmStripeCardPayment(stripeIntent, state, stripeRef);
		state.isRecurring
			? (payload = {
					...payload,
					donation_id: stripeIntent.donation_id,
					intent_client_secret: stripeIntent.payment_intent,
					start_date: stripeIntent.start_date,
					end_date: stripeIntent.end_date,
					status: stripeIntent.status,
					invoice_id: stripeIntent.invoice_id,
					stripe_sub_id: stripeIntent.stripe_sub_id,
					...stripeResponse,
			  })
			: (payload = {
					...payload,
					donation_id: stripeIntent.donation_id,
					intent_client_secret: stripeIntent.client_secret,
					...stripeResponse,
			  });
		state.isFundraiserCheckout ? store.dispatch(donationActions.checkoutStripe(payload)) : store.dispatch(donationActions.checkoutStripe(payload, 1));
	} catch (error) {
		throw error;
	}
};

export const handleBankCheckout = async (checkoutPayload) => {
	const checkoutDetails = store.getState().donationCheckout;

	const bankTransferPayload = {
		...checkoutPayload,
		bank_id: checkoutDetails.selectedBank.bank_id,
		attachment: checkoutDetails.bankSlip.attachment,
	};
	checkoutDetails.isFundraiserCheckout
		? store.dispatch(donationActions.checkoutBankTransfer(bankTransferPayload))
		: store.dispatch(donationActions.checkoutBankTransfer(bankTransferPayload, 1));
};

export const handleChequeCheckout = async (checkoutPayload) => {
	const checkoutDetails = store.getState().donationCheckout;

	const chequePayload = {
		...checkoutPayload,
		cheque_no: checkoutDetails.chequeNumber,
	};
	checkoutDetails.isFundraiserCheckout
		? store.dispatch(donationActions.checkoutChequeDeposit(chequePayload))
		: store.dispatch(donationActions.checkoutChequeDeposit(chequePayload, 1));
};

export const handleHBLCheckout = async (checkoutPayload) => {
	let hblPayload = {};
	const checkoutDetails = store.getState().donationCheckout;

	try {
		const response = await axios.get(TCF_URL.GET_USER_IP);
		const userIp = response.data.IPv4;
		hblPayload = { ...checkoutPayload, customer_ip_address: userIp };
	} catch {
		hblPayload = { ...checkoutPayload, customer_ip_address: '127.0.0.1' };
	}
	hblPayload = {
		...hblPayload,
		bill_to_address_city: checkoutDetails.userContactDetails.city,
		bill_to_address_postal_code: checkoutDetails.userContactDetails.zipCode,
		bill_to_address_state: checkoutDetails.userContactDetails.countryState,
		bill_to_phone: checkoutDetails.userContactDetails.contactNumber,
		bill_to_address_country: checkoutDetails.selectedCountry.code,
	};
	await store.dispatch(donationActions.getHBLConfig(hblPayload));
	// $("#payment_form").submit();
	$('#payment_form').trigger('submit');
	//     $("#payment_form").requestSubmit();
};

export const handlePaypalCheckout = async (checkoutPayload) => {
	const checkoutDetails = store.getState().donationCheckout;

	if (checkoutDetails.isRecurring) {
		checkoutDetails.isFundraiserCheckout
			? await store.dispatch(donationActions.checkoutRecurringPaypal(checkoutPayload))
			: await store.dispatch(donationActions.checkoutRecurringPaypal(checkoutPayload, 1));
	} else {
		checkoutDetails.isFundraiserCheckout
			? await store.dispatch(donationActions.checkoutOnetimePaypal(checkoutPayload))
			: await store.dispatch(donationActions.checkoutOnetimePaypal(checkoutPayload, 1));
	}
};

export const handleACHCheckout = async (checkoutPayload) => {
	const globalState = store.getState();

	const checkoutDetails = globalState.donationCheckout;
	const ACHReference = globalState.checkoutPaymentRefs.ACHReference;

	const paymentIntent = await ACHReference.current.confirmUsBankAccountPayment();

	let achPayload = {
		...checkoutPayload,
		...paymentIntent,
		is_google_apple_pay: false,
		is_ach: 1,
	};

	if (checkoutDetails.isRecurring) {
		achPayload = {
			...achPayload,
			...checkoutDetails.achRecurringDetails,
		};
	}

	checkoutDetails.isFundraiserCheckout
		? store.dispatch(donationActions.checkoutStripe(achPayload))
		: store.dispatch(donationActions.checkoutStripe(achPayload, 1));
};

export const getACHPaymentIntent = async (donationDetails) => {
	if (!Object.keys(store.getState().validationErrors).length)
		try {
			const payload = {
				channel: 'p2p',
				currency_id: donationDetails.selectedCountry.currency.id,
				country_id: donationDetails.selectedCountry.id,
				bill_to_forename: compiledName(donationDetails.userContactDetails.firstName),
				bill_to_surname: compiledName(donationDetails.userContactDetails.lastName),
				bill_to_email: donationDetails.userContactDetails.email,
				bill_to_phone: donationDetails.userContactDetails.contactNumber,
				city: donationDetails.userContactDetails.city,
				zip_code: donationDetails.userContactDetails.zipCode,
				bill_to_address_line1: donationDetails.userContactDetails.address,
				donation_amount: totalCheckoutDonation(donationDetails),
				payment_method_name: ACH,
				is_recurring: donationDetails.isRecurring ? 1 : 0,
			};

			const paymentIntent = await donationAPIs.getACHIntent(payload);
			return paymentIntent.data.success;
		} catch (error) {
			throw error;
		}
	else {
		store.dispatch(checkoutActions.resetCheckoutPaymentMethod());
		throw new Error('Required fields are missing');
	}
};

export const handleGoogleAppleCheckout = async (checkoutPayload) => {
	const globalState = store.getState();

	const checkoutDetails = globalState.donationCheckout;
	const googleApplePaymentId = globalState.googleApplePaymentId;

	const googleApplePayload = {
		...checkoutPayload,
		is_google_apple_pay: true,
		google_apple_device_name: convertFirstLetterToUpperCase(checkoutDetails.selectedPaymentMethod),
	};
	if (checkoutDetails.isRecurring) googleApplePayload.payment_method = googleApplePaymentId;

	await handleStripe(googleApplePayload, checkoutDetails);
};

export const handleStripeCheckout = async (checkoutPayload) => {
	const globalState = store.getState();

	const checkoutDetails = globalState.donationCheckout;
	const stripeReference = globalState.checkoutPaymentRefs.stripeReference;

	let stripePayload = {
		...checkoutPayload,
		is_google_apple_pay: false,
		google_apple_device_name: null,
	};

	try {
		const response = await stripeReference.current.getPaymentMethod();

		if (response.paymentMethod) stripePayload = { ...stripePayload, payment_method: response.paymentMethod.id };
	} catch (error) {
		throw error;
	}

	await handleStripe(stripePayload, checkoutDetails);
};
